const DEFAULT_EXCLUDED_CLASSNAMES = [
    'c-baseElementWrapper__borderItems',
    'modal',
    'c-multiSelectElement__answerContainer',
    'c-yesNoQuestion__comment',
];

export function slideToImageFilter(node: Node): boolean {
    return !DEFAULT_EXCLUDED_CLASSNAMES.includes((node as HTMLElement).className);
}
